import type { CityData } from "@/libs/bounce/cities"
import { asInterpolateText } from "@/libs/prismic/helpers"
import type { Interpolations } from "@/screens/LuggageStorage/CityScreen/hooks/useInterpolations"

export const useFaqs = ({ city, interpolations }: { city: CityData; interpolations: Interpolations }) => {
  if (!city.faq || city.faq.length <= 0) {
    return null
  }

  return city.faq
    .map(item => {
      const question = asInterpolateText({ field: item.question, interpolations })
      const answer = asInterpolateText({ field: item.answer, interpolations })

      return { id: question, question, answer }
    })
    .filter(({ question, answer }) => !!question && !!answer)
}
